export const uk = {
    id: 'id',
    'product-description': 'описание продукта',
    'product-name': 'название продукта'
};
